module.exports = __webpack_public_path__ + "static/travel-to-the-moon-mobile-f25f4daa9d6388ed749dd36cb48afd7b.svg";